module.exports = __webpack_public_path__ + "static/media/No SubcontractorsNew@2x.c2fe9821.png";